export const ASSET_HIERARCHY_IMPORT_COMPLETED =
  "LSNG.Admin.PublishedLanguage.Events.ImportHierarchy.AssetHierarchyImportCompleted";
